<div class="col-md sdk-top-controls">
    <div class="sdk-version-info">
        <label class="sdk-version-label">sdk version:</label>
        <div class="sdk-version">{{ SdkTesterService.version }}</div>
        <br />
    </div>

    <label class="tester-text">kc listening:</label>
    <div [ngClass]="{ dot: true, 'not-listening': !SdkTesterService.sdkKcIsListening, listening: SdkTesterService.sdkKcIsListening }"></div>
    <label class="tester-text">encoder listening:</label>
    <div [ngClass]="{ dot: true, 'not-listening': !SdkTesterService.sdkEncoderIsListening, listening: SdkTesterService.sdkEncoderIsListening }"></div>
    <br />
    <label>
        Advanced Mode:
        <input
            type="checkbox"
            class="sdk-tester-checkbox kc-input"
            id="kc-sdk-advanced-mode"
            name="kc-sdk-advanced-mode"
            (change)="advancedModeOnChange()"
            [(ngModel)]="SignInService.advancedMode" />
    </label>
</div>
<div class="container" [ngClass]="SignInService.advancedMode ? 'sdk-advanced-mode-container' : 'sdk-simple-mode-container'">
    <div class="row"></div>
    <div class="row" *ngIf="!SignInService.advancedMode">
        <div class="col-md">
            <app-sign-in [inAdvancedMode]="false"></app-sign-in>
        </div>
    </div>

    <div class="row sdk-advanced-row" *ngIf="SignInService.advancedMode">
        <div class="col-md-3 sdk-tester-input-side">
            <input type="button" class="tester-clear-tester" value="Clear Tester" id="kc-sdk-clear-tester" (click)="clearInputOutput()" />
            <input
                type="button"
                class="tester-close-windows"
                [disabled]="!SdkTesterService.sdkKcIsListening && !SdkTesterService.sdkEncoderIsListening"
                value="Close All KC Windows"
                id="kc-sdk-close-windows"
                (click)="SdkTesterService.closeAllKCWindows()" />
            <br />
            <H2 class="tester-text">Select API:</H2>

            <br />
            <select id="kc-workflow-available-apis"
                    class="tester-workflow-available-api"
                    [(ngModel)]="selectedApi"
                    (change)="onSelectedNewWorkflowApiChange()">
              <option value="launch KC">launch KC</option>
              <option value="launch KC Sentinel">launch KC Sentinel</option>
              <option value="launch Encoder">launch Encoder</option>
              <option value="assignConfig">assignConfig</option>
              <option value="setDemographics">setDemographics</option>
              <option value="setAuthToken">setAuthToken</option>
              <option *ngFor="let api of apiMethods" [ngValue]="api.name">{{ api.name }}</option>
            </select>
            <br />

            <div class="sdk-workflow-api-buttons">
                <br />
                <input
                    type="button"
                    class="sdk-callApi-button"
                    value="Call API"
                    id="kc-sdk-run-workflow"
                    (click)="callApi()"
                 />
            </div>
            <br />
            <br />
        </div>
        <div class="col-md-4 sdk-tester-left-side">
            <div class="sdk-tester-input-area">
                <textarea
                    name="workflowInput"
                    id="kc-sdk-workflow-input"
                    placeholder="Workflow input"
                    spellcheck="false"
                    [(ngModel)]="SdkTesterService.workflowInput"
                    class="tester-text-area-advanced ng-pristine ng-valid ng-touched"></textarea>
                <br />
            </div>
        </div>
        <div class="col-md-5 sdk-tester-right-side">
            <div class="sdk-tester-output-area">
                <input type="button" class="tester-clear-output-tester" value="Clear Output" id="kc-sdk-clear-tester" (click)="clearOutput()" />

                <textarea
                    placeholder="Output"
                    name="outputJson"
                    id="kc-sdk-input"
                    spellcheck="false"
                    [(ngModel)]="SdkTesterService.outputJson"
                    class="tester-text-area-advanced ng-pristine ng-valid ng-touched"></textarea>
                <br />
            </div>
        </div>
    </div>
</div>
